import Service from "../../../Services/index";

const transportation = {
    namespaced: true,
    state: {
        transportationList: [],
        form: {
            name: "",
            phone: "",
            phone1: "",
            phone2: "",
            address: "",
            big_car_cost: "",
            company_car_cost: "",
            small_car_cost: "",
            transport_line_id: "",
        },
        dataPaginate: {
            current_page: 1,
            from: 1,
            last_page: 1,
            per_page: 1,
            total: 1,
            to: 1
        },
        search: {
            name: ""
        }
    },
    mutations: {
        SET_TRANSPORTATION: (state, res) => {
            state.transportationList = res.data;
            state.dataPaginate = {
                current_page: res.current_page,
                from: res.form,
                last_page: res.last_page,
                per_page: res.per_page,
                total: res.total,
                to: res.to
            };
        },
        SET_FORM_TRANSPORTATION: (state, data) => {
            state.form = data;
        },
        CLEAR_FORM_TRANSPORTATION: (state) => {
            state.form = {
                name: "",
                phone: "",
                phone1: "",
                phone2: "",
                address: "",
                big_car_cost: "",
                company_car_cost: "",
                small_car_cost: "",
                transport_line_id: "",
            }
        },
        CLEAR_SEARCH: (state) => {
            state.search = {
                name: "",

            }
        },
        SET_TRANSPORTATION_SHOW: (state, res) => {
            state.transportation = res.data;
            state.dataPaginate = {
                current_page: res.current_page,
                from: res.form,
                last_page: res.last_page,
                per_page: res.per_page,
                total: res.total,
                to: res.to
            };
        },
    },
    actions: {
        setTransport({commit}, page = 1) {
            return Service.Transportation.getTransportationList(page)
                .then(data => {
                    commit("SET_TRANSPORTATION", data)
                })
        },
        getAll({commit}) {
            return Service.Transportation.getAllTransportation();
        },
        show({commit}, id) {
            return Service.Transportation.showTransportation(id)
                .then(data => {
                    commit("SET_FORM_TRANSPORTATION", data)
                })
        },
        save({commit, state}, {id, data}) {
            //console.log(data)
            if (!id) {
                //create
                return Service.Transportation.createTransportation(data)
                    .then(res => {
                        //console.log('create');
                    })
            } else {
                return Service.Transportation.updateTransportation(id, data)
                    .then(res => {
                        //console.log('update');
                    })
            }
        },
        delete({commit}, id) {
            return Service.Transportation.deleteTransportation(id)
        },
        clearForm({commit}) {
            commit("CLEAR_FORM_TRANSPORTATION");
        },
        clearSearch({commit}) {
            commit("CLEAR_SEARCH");
        },
        search({commit}, data) {
            return Service.Transportation.searchTransportation(data).then(res => {
                commit("SET_TRANSPORTATION", res)
            })
        },
        setTransportShow({commit}, page = 1) {
            return Service.Transportation.getTransportationShow(page).then(res => {
                commit("SET_TRANSPORTATION", res);
            });
        },
        updateTransportationFee({commit}, data) {
            return Service.Transportation.updateTransportationFee(data);
        }
    }
};
export default transportation;
